// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-page .header-part{
    box-shadow: 0px 1px 15px #0000000f;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.chat-page button{
    border: none !important;
}
.chat-page .header-part .name-call{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.chat-page .header-part .back-button{
    width: 30%;
    border-right: 1px solid #EAEAEA;
    padding: 30px 50px;
}
.chat-page .header-part .back-button .back{
    border: 1px solid #E3E3E3;
    border-radius: 14px;
    background-color: transparent;
    width: 60px;
    height: 60px;
}
.chat-page .header-part .back-button .back img{
    transform: rotate(-180deg);
}
.chat-page .header-part .name-call{
   width: 70%;
    padding: 30px 50px;
}
.chat-page .header-part .name-call .profile{
    display: flex;
    align-items: center;
}
.chat-page .header-part .name-call .profile .user-name p{
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 500;
}
.chat-page .header-part .name-call .profile .user-name p.status{
    font-size: 12px;
    font-weight: 400;
    color: #4CAA4D;
}
.chat-page .header-part .name-call .call{
    box-shadow: 0px 1px 15px #0000000f;
    border-radius: 14px;
    background-color: transparent;
    width: 60px;
    height: 60px;
}
.chat-page .main-chat-part{
    display: flex;
    height: 86vh;
    overflow: hidden;
}
.chat-page .main-chat-part .chat-side-part{
   width: 30%;
    box-shadow: 0px 10px 15px #0000000f;
    padding: 30px 50px;
}
.chat-page .main-chat-part .messages-part{
    width: 70%;
    position: relative;
}
.chat-page .main-chat-part .messages-part .chatting{
    padding: 30px 50px;
    height: 90vh;
    overflow: auto;
}
.chat-page .main-chat-part .messages-part .messages{
   
    width: 50%;
}
.chat-page .main-chat-part .messages-part .messages .message-card{
    box-shadow: 0px 1px 15px #0000000f;
    padding: 14px;
    border-radius: 14px;
}
.chat-page .main-chat-part .messages-part .messages.reciver .message-card {
    border-top-left-radius: 0;
    background-color: #fff;
}
.chat-page .main-chat-part .messages-part .messages.reciver{
    clear: both;
}
.chat-page .main-chat-part .messages-part .messages.sender{
    float: right;
}
.chat-page .main-chat-part .messages-part .messages.sender .message-card{
    background-color: #F5F2F2;
    border-top-right-radius: 0;
}
.chat-page .main-chat-part .messages-part .messages p.timer{
    font-size: 12px;
    font-weight: 400;
    color: #ADADAD;
    text-align: right;
    padding-right: 10px;
    padding-top: 8px;
}
.chat-page .main-chat-part .messages-part .messages .message-card p{
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 0;
}
.chat-page .main-chat-part .messages-part  .message-typing-block{
    box-shadow: 8px 1px 15px #0000000f;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    padding: 18px 60px;
    position: absolute;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    z-index: 9;
}
.chat-page .main-chat-part .messages-part  .message-typing-block .input-box{
    flex: 2 1;
    position: relative;
}
.file-attach{
    position: absolute;
    right: 15px;
    top: 10px;
    background-color: transparent;
}
.image-attach{
    position: absolute;
    right: 20px;
    top: 10px;
    background-color: transparent;
}
.file-attach:hover, .image-attach:hover, .file-attach.btn:focus, .image-attach.btn:focus{
    background-color: transparent;
}
.chat-page .main-chat-part .messages-part  .message-typing-block .msg-type{
    border: 1px solid #E3E3E3;
    border-radius: 40px;
    width: 100%;
    padding: 16px;
}
.chat-page .main-chat-part .messages-part  .message-typing-block .sent{
    width: 50px;
    height: 50px;
    background-color: #FF6036;
    border-radius: 50%;
}
.chat-page .chatting-person .chat-card{
    display: flex;
    align-items: center;
    gap: 15px;
    box-shadow: 0px 1px 15px #0000000f;
    background-color: #fff;
    border-radius: 14px;
    padding: 10px;
    margin-bottom: 20px;
    cursor: pointer;
}
.chat-page .chatting-person .chat-card.active{
    border: 1px solid #FF6036;
}
.chat-page .chatting-person .chat-card .text-block{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.chat-page .chatting-person .chat-card .text-block p{
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 500;
}
.chat-page .chatting-person .chat-card .text-block p.time{
    font-size: 10px;
    color: #ADADAD;
    margin-top: -4px;
}
.chat-page .chatting-person .chat-card .text-block small{
    font-size: 12px;
    color: #ADADAD;
}
.chat-page .chatting-person .chat-card .text-block  p.msg-badge{
    background-color: #FF6036;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6px;
}
.chat-page .chat-person .search-box{
    width: 100%;
    position: relative;
    margin-bottom: 20px;
}
.chat-page .chat-person .search-box .searchInput{
    width: 100%;
    border: 1px solid #E3E3E3;
    border-radius: 26px;
    padding: 10px 16px 10px 50px;
}
.chat-page .chat-person .search-box .searchIcon{
    position: absolute;
    top: 10px;
    left: 16px;
}
/* Add this to your chat.css file */
.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  .chatting {
    max-height: 75vh;
    overflow-y: scroll;
    overflow-y: -moz-scrollbars-vertical;
    overflow-y: -webkit-scrollbar;
  }
  
  .chatting::-webkit-scrollbar {
    width: 12px;
  }
  
  .chatting::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  
  .chatting::-webkit-scrollbar-thumb {
    background: #888; 
  }
  
  .chatting::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
  
  .start-chat{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0; 
  }

  .unread-indicator {
    background-color: #ff6036; /* Background color */
    color: white; /* Font color */
    font-size: 12px; /* Font size */
    font-weight: bold; /* Bold font */
    width: 25px; /* Fixed width to make it square */
    height: 25px; /* Fixed height to make it square */
    display: flex; /* Flexbox for centering content */
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
    border-radius: 25px; /* Rounded corners */
    margin-left: 8px; /* Spacing from the left */
  }
  
  .unread-indicator.right {
    float: right; /* Align to the right */
    margin-right: 12px; /* Spacing from the right */
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/chat.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;GACG,UAAU;IACT,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;AACA;GACG,UAAU;IACT,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;AACA;;IAEI,UAAU;AACd;AACA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,SAAO;IACP,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;IAChD,YAAY,EAAE,eAAe;IAC7B,eAAe,EAAE,cAAc;IAC/B,iBAAiB,EAAE,cAAc;IACjC,WAAW,EAAE,kCAAkC;IAC/C,YAAY,EAAE,mCAAmC;IACjD,aAAa,EAAE,kCAAkC;IACjD,mBAAmB,EAAE,uBAAuB;IAC5C,uBAAuB,EAAE,yBAAyB;IAClD,mBAAmB,EAAE,oBAAoB;IACzC,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,YAAY,EAAE,uBAAuB;IACrC,kBAAkB,EAAE,2BAA2B;EACjD","sourcesContent":[".chat-page .header-part{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    display: flex;\r\n    align-items: center;\r\n    overflow: hidden;\r\n}\r\n.chat-page button{\r\n    border: none !important;\r\n}\r\n.chat-page .header-part .name-call{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.chat-page .header-part .back-button{\r\n    width: 30%;\r\n    border-right: 1px solid #EAEAEA;\r\n    padding: 30px 50px;\r\n}\r\n.chat-page .header-part .back-button .back{\r\n    border: 1px solid #E3E3E3;\r\n    border-radius: 14px;\r\n    background-color: transparent;\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n.chat-page .header-part .back-button .back img{\r\n    transform: rotate(-180deg);\r\n}\r\n.chat-page .header-part .name-call{\r\n   width: 70%;\r\n    padding: 30px 50px;\r\n}\r\n.chat-page .header-part .name-call .profile{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.chat-page .header-part .name-call .profile .user-name p{\r\n    margin-bottom: 0;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.chat-page .header-part .name-call .profile .user-name p.status{\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #4CAA4D;\r\n}\r\n.chat-page .header-part .name-call .call{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    border-radius: 14px;\r\n    background-color: transparent;\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n.chat-page .main-chat-part{\r\n    display: flex;\r\n    height: 86vh;\r\n    overflow: hidden;\r\n}\r\n.chat-page .main-chat-part .chat-side-part{\r\n   width: 30%;\r\n    box-shadow: 0px 10px 15px #0000000f;\r\n    padding: 30px 50px;\r\n}\r\n.chat-page .main-chat-part .messages-part{\r\n    width: 70%;\r\n    position: relative;\r\n}\r\n.chat-page .main-chat-part .messages-part .chatting{\r\n    padding: 30px 50px;\r\n    height: 90vh;\r\n    overflow: auto;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages{\r\n   \r\n    width: 50%;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages .message-card{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    padding: 14px;\r\n    border-radius: 14px;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages.reciver .message-card {\r\n    border-top-left-radius: 0;\r\n    background-color: #fff;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages.reciver{\r\n    clear: both;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages.sender{\r\n    float: right;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages.sender .message-card{\r\n    background-color: #F5F2F2;\r\n    border-top-right-radius: 0;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages p.timer{\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #ADADAD;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    padding-top: 8px;\r\n}\r\n.chat-page .main-chat-part .messages-part .messages .message-card p{\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    margin-bottom: 0;\r\n}\r\n.chat-page .main-chat-part .messages-part  .message-typing-block{\r\n    box-shadow: 8px 1px 15px #0000000f;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 15px;\r\n    padding: 18px 60px;\r\n    position: absolute;\r\n    width: 100%;\r\n    bottom: 0;\r\n    background-color: #fff;\r\n    z-index: 9;\r\n}\r\n.chat-page .main-chat-part .messages-part  .message-typing-block .input-box{\r\n    flex: 2;\r\n    position: relative;\r\n}\r\n.file-attach{\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 10px;\r\n    background-color: transparent;\r\n}\r\n.image-attach{\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 10px;\r\n    background-color: transparent;\r\n}\r\n.file-attach:hover, .image-attach:hover, .file-attach.btn:focus, .image-attach.btn:focus{\r\n    background-color: transparent;\r\n}\r\n.chat-page .main-chat-part .messages-part  .message-typing-block .msg-type{\r\n    border: 1px solid #E3E3E3;\r\n    border-radius: 40px;\r\n    width: 100%;\r\n    padding: 16px;\r\n}\r\n.chat-page .main-chat-part .messages-part  .message-typing-block .sent{\r\n    width: 50px;\r\n    height: 50px;\r\n    background-color: #FF6036;\r\n    border-radius: 50%;\r\n}\r\n.chat-page .chatting-person .chat-card{\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    background-color: #fff;\r\n    border-radius: 14px;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    cursor: pointer;\r\n}\r\n.chat-page .chatting-person .chat-card.active{\r\n    border: 1px solid #FF6036;\r\n}\r\n.chat-page .chatting-person .chat-card .text-block{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n}\r\n.chat-page .chatting-person .chat-card .text-block p{\r\n    margin-bottom: 0;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.chat-page .chatting-person .chat-card .text-block p.time{\r\n    font-size: 10px;\r\n    color: #ADADAD;\r\n    margin-top: -4px;\r\n}\r\n.chat-page .chatting-person .chat-card .text-block small{\r\n    font-size: 12px;\r\n    color: #ADADAD;\r\n}\r\n.chat-page .chatting-person .chat-card .text-block  p.msg-badge{\r\n    background-color: #FF6036;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    color: #fff;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    width: 22px;\r\n    height: 22px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 6px;\r\n}\r\n.chat-page .chat-person .search-box{\r\n    width: 100%;\r\n    position: relative;\r\n    margin-bottom: 20px;\r\n}\r\n.chat-page .chat-person .search-box .searchInput{\r\n    width: 100%;\r\n    border: 1px solid #E3E3E3;\r\n    border-radius: 26px;\r\n    padding: 10px 16px 10px 50px;\r\n}\r\n.chat-page .chat-person .search-box .searchIcon{\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 16px;\r\n}\r\n/* Add this to your chat.css file */\r\n.spinner-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n  \r\n  .chatting {\r\n    max-height: 75vh;\r\n    overflow-y: scroll;\r\n    overflow-y: -moz-scrollbars-vertical;\r\n    overflow-y: -webkit-scrollbar;\r\n  }\r\n  \r\n  .chatting::-webkit-scrollbar {\r\n    width: 12px;\r\n  }\r\n  \r\n  .chatting::-webkit-scrollbar-track {\r\n    background: #f1f1f1; \r\n  }\r\n  \r\n  .chatting::-webkit-scrollbar-thumb {\r\n    background: #888; \r\n  }\r\n  \r\n  .chatting::-webkit-scrollbar-thumb:hover {\r\n    background: #555; \r\n  }\r\n  \r\n  .start-chat{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0; \r\n  }\r\n\r\n  .unread-indicator {\r\n    background-color: #ff6036; /* Background color */\r\n    color: white; /* Font color */\r\n    font-size: 12px; /* Font size */\r\n    font-weight: bold; /* Bold font */\r\n    width: 25px; /* Fixed width to make it square */\r\n    height: 25px; /* Fixed height to make it square */\r\n    display: flex; /* Flexbox for centering content */\r\n    align-items: center; /* Vertical alignment */\r\n    justify-content: center; /* Horizontal alignment */\r\n    border-radius: 25px; /* Rounded corners */\r\n    margin-left: 8px; /* Spacing from the left */\r\n  }\r\n  \r\n  .unread-indicator.right {\r\n    float: right; /* Align to the right */\r\n    margin-right: 12px; /* Spacing from the right */\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
